import { FC } from "react";
import { Dropdown, Space, Table, message } from "antd";
import type { ColumnsType } from "antd/es/table";
import { EllipsisOutlined } from "@ant-design/icons";
import { formatDate } from "utils/dateFormat";
import { useNavigate } from "react-router-dom";
import { DataResponseAgentNewsList, DataResponseAgentNewsListData } from "services/interface/news/news.interface";
import { useDeleteNews } from "hooks/useNews";

interface TableCampaignProps {
  // selectDate?: any;
  data?: DataResponseAgentNewsList
  reload: () => void;
}

const TableCampaign: FC<TableCampaignProps> = ({ data, reload}) => {
  const navigate = useNavigate();

  const { mutate } = useDeleteNews();

const handleEdit = (id: string) => {
  navigate(`/campaign/update-campaign/${id}`);
};

const handleDelete = (id: string) => {
  // console.log("Delete clicked for ID:", id);
  mutate({
    id: id
  }, {
    onSuccess: (data) => {
      if (data.status === "success") {
        message.success("ลบข่าวสารและโปรโมชั่นสำเร็จ");   
        reload();
      } else {
        message.error("ลบข่าวสารและโปรโมชั่นไม่สำเร็จ");
      }
    },
    onError: () => {
      message.error("ลบข่าวสารและโปรโมชั่นไม่สำเร็จ");
    },
  });
};

const items = [
  {
    key: '1',
    label: 'Edit',
  },
  {
    key: '2',
    label: 'Delete',
  },
];
  const columns: ColumnsType<DataResponseAgentNewsListData> = [
    {
      title: "หัวข้อ",
      dataIndex: "topic",
      key: "topic",
      width: 300,
    }, 
    {
      title: "ประเภทข่าวสารและโปรโมชั่น",
      dataIndex: "new_type",
      key: "new_type",
      align:"center",
      width: 160,
      render: (new_type) => (
        <div style={{ display: "flex", flexDirection: "row", textAlign: "center", justifyContent: "center" }}>
          {new_type === "news" ? "ข่าวสาร" : new_type === "promotion" ? "โปรโมชั่น" : "อื่นๆ"}
        </div>
      ),
    }, 
    {
      title: "วันที่เริ่มต้น",
      dataIndex: "start_date",
      key: "start_date",
      width: 160,
      align:"center",
      render: (startDate) => (
        <div style={{ display: "flex", flexDirection: "row", textAlign: "center", justifyContent: "center" }}>
          {formatDate(startDate)}
        </div>
      ),
    }, 
    {
      title: "วันที่สิ้นสุด",
      dataIndex: "end_date",
      key: "end_date",
      align:"center",
      width: 160,
      render: (endDate) => (
        <div style={{ display: "flex", flexDirection: "row", textAlign: "center", justifyContent: "center" }}>
          {formatDate(endDate)}
        </div>
      ),
    }, 
    {
      title: "สถานะการเปิดใช้งาน",
      dataIndex: "is_active",
      align:"center",
      key: "is_active",
      width: 160,
      render: (isActive) => (
        <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", textAlign: "center" }}>
          <span 
            style={{ color: isActive ? "green" : "#b07919" }}>
            {isActive ? "เปิดใช้งาน" : "ปิดใช้งาน"}
          </span>
        </div>
      ),
    }, 
    {
      title: "สถานะการอนุมัติ",
      dataIndex: "is_approve",
      align:"center",
      key: "is_approve",
      width: 160,
      render: (isApprove) => (
        <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", textAlign: "center" }}>
          <span 
            style={{ color: isApprove ? "green" : "#b07919" }}>
            {isApprove ? "อนุมัติแล้ว" : "กำลังดำเนินการ"}
          </span>
        </div>
      ),
    }, 
    {
      title: "เครื่องมือ",
      dataIndex: "id",
      align:"center",
      key: "id",
      fixed: "right",
      width: 100,
      render: (id) => (
        <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", cursor: "pointer"
          }}
        >
        <Space size="middle">
          <Dropdown
            menu={{
              items,
              onClick: ({ key }) => {
                if (key === '1') {
                  handleEdit(id);
                } else if (key === '2') {
                  handleDelete(id)
                }
              }
            }}
          >
            <div><EllipsisOutlined /></div>
          </Dropdown>
        </Space>
      </div>
      ),
    }
  ];

  return (
    <>
      <Table
        columns={columns}
        dataSource={data?.news}
        bordered
        size="middle"
        scroll={{ x: "max-content" }}
        expandable={{
         defaultExpandAllRows: true,
        }}
      />
    </>
  );
};

export default TableCampaign;
